import { useRef } from "react"
import { debounce } from "es-toolkit"
import { XIcon } from "lucide-react"

import Input from "@/components/core/Input"
import Icon from "@/components/Icon"
import { Button } from "@/components/ui/button"

type Props = {
  defaultValue: string
  onChange: (text: string) => void
  placeholder?: string
}

/**
 * Uncontrolled input to search by name or phone, we don't need state here
 */
export function SearchBox({ defaultValue, onChange, placeholder }: Props) {
  const ref = useRef<HTMLInputElement | null>(null)

  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    onChange(event.target.value)
  }
  function handleReset() {
    if (ref.current) ref.current.value = ""
    onChange("")
  }

  const debouncedChange = debounce(handleChange, 300)

  return (
    <div className="relative">
      <Input
        ref={ref}
        name="search"
        defaultValue={defaultValue}
        onChange={debouncedChange}
        target={<Icon name="search" className="text-muted-foreground" />}
        inputClassName="h-10 min-w-[300px]"
        placeholder={placeholder || "dashboard.selectOptions.searchPlaceholder"}
      />
      <Button
        onClick={handleReset}
        variant="ghost"
        size="icon"
        className="absolute top-2 right-2 size-6 max-w-[300px]"
      >
        <XIcon className="size-4" />
      </Button>
    </div>
  )
}
